import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { LegendaryGame } from './legendary-game.interface'

@Component({
    selector: 'legendary-game',
    template: require('./legendary-game.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class LegendaryGameComponent {
    @Input() game: LegendaryGame;
    @Input() counter: number;

    @Output() addExcluded = new EventEmitter();
    @Output() toggleSidebar = new EventEmitter();

    displaySecond: boolean = false;
    displayThird: boolean = false;
    displayFourth: boolean = false;

    ngOnChanges(changes: SimpleChanges) {
        this.displaySecond = false;
        this.displayThird = false;
        this.displayFourth = false;
    }

    onExcludedClick() {
        this.addExcluded.emit(this.game);
    }

    toggleSidebarClick() {
        this.toggleSidebar.emit();
    }

    revealSecondMastermind() {
        this.displaySecond = true;
    }

    revealThirdMastermind() {
        this.displayThird = true;
    }

    revealFourthMastermind() {
        this.displayFourth = true;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/legendary/legendary-game.component.ts